// extracted by mini-css-extract-plugin
var _1 = "webpack-components-shared-ExtractionTemplateHeader-TemplateToolInfo-module__ExtractionOne";
var _2 = "webpack-components-shared-ExtractionTemplateHeader-TemplateToolInfo-module__ExtractionTwo";
var _3 = "webpack-components-shared-ExtractionTemplateHeader-TemplateToolInfo-module__IconWrapper";
var _4 = "webpack-components-shared-ExtractionTemplateHeader-TemplateToolInfo-module__SubTitle";
export { _1 as "ExtractionOne", _2 as "ExtractionTwo", _3 as "IconWrapper", _4 as "SubTitle" }
